<div class="report-content">
  <ng-content select="ndt-report-output-header-bar"></ng-content>
  @if (!viewMode || viewMode === 'Full') {
    <ng-content></ng-content>
  }

  <!-- <ndt-report-output-charts
  [charts]="visibleCharts"
  (expand)="onExpand($event)"
  (showFullReport)="onShowFullReport()"
></ndt-report-output-charts> -->
</div>
